module.exports = __webpack_public_path__ + "static/media/02-banner-04-perisur@2x.a464b782.jpg";